//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import { useContext } from "react";

// custom pages
import config from "config/index";
import Context from "context/context";

const Redeem = () => {
  const { state, dispatch } = useContext(Context);

  async function getBilltoAccDetails(req) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let userId = (await state.userInfo) && state.userInfo.user_id;
      let res = await fetch(
        `${config.host}/cdr-panel/redeem/get-billtoacc/${userId}`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) {}
  }

  async function getPointBreak(req) {
    try {
      let userId = (await state.userInfo) && state.userInfo.user_id;
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(req),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/redeem/get-pointbreak/${userId}`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) {}
  }

  async function confirmRedeem(data) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(data),
      };
      let res = await fetch(`${config.host}/cdr-panel/redeem/confirm`, obj);
      let body = await res.json();
      return body;
    } catch (err) {}
  }

  async function getBillingAccountRedeem(loyaltyId) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/redeem/get-billingaccount?loyaltyId=${loyaltyId}`,
        obj
      );
      let body = await res.json();
      return body;
    } catch (err) {}
  }
  async function allowRedeem() {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };

  
      let res = await fetch(`${config.host}/cdr-panel/redeem/allow-redeem`,obj);
      let body = await res.json();
      return body;
    } catch (err) {}
  }

  async function getShiptoList(query) {
    try {
      const {searchValue, loyaltyId} = query;
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };  
      let res = await fetch(`${config.host}/cdr-panel/redeem/shipto-list?searchValue=${searchValue}&loyaltyId=${loyaltyId}`,obj);
      let body = await res.json();
      return body;
    } catch (err) {}
  }

  return {
    getBilltoAccDetails,
    getPointBreak,
    confirmRedeem,
    getBillingAccountRedeem,
    allowRedeem,
    getShiptoList
  };
};

export default Redeem;
